import { createThunk } from "../../utils/CreateThunk";
import * as usersBackendAPI from "../../services/userProfileService";
import {
  SYNC_USER_PROFILE,
  SYNC_USER_PROFILE_RESET,
} from "../actionTypes/index";

export const syncUserProfile = createThunk({
  apiCall: usersBackendAPI.syncUserPorfile,
  type: SYNC_USER_PROFILE,
});

export const resetSyncUserProfile = () => ({
    type: SYNC_USER_PROFILE_RESET,
});
